module.exports = __webpack_public_path__ + "static/duke.deef4e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/duke.png
// module id = 2182
// module chunks = 61762850755587